import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const LoadingState = () => {
  return (
    <Box style={{ flexBasis: '100%' }}>
      <Box gap="s8" flexDirection="row" alignItems="center">
        <Skeleton width="s200" height="s24" /> <Skeleton width="s120" height="s16" />
      </Box>
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="flexStart"
        flexWrap="wrap"
        paddingTop="s16"
        paddingBottom="s16"
        gap="s16"
        flexGrow
      >
        <Skeleton height="s600" />
      </Box>
    </Box>
  )
}

export default LoadingState
